import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { scrollToElement } from "../lib/utils";

function Success({
  className,
  message,
  heavyStyle,
  scrollTo = false,
}: {
  className?: string;
  heavyStyle?: boolean;
  message?: string;
  scrollTo?: boolean;
}): JSX.Element | null {
  const errorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (message && scrollTo && errorRef.current) {
      scrollToElement(errorRef.current);
    }
  }, [message, scrollTo]);

  return !message ? null : (
    <motion.div
      className={`rounded-md ${heavyStyle ? "p-2" : "mt-2 "} ${
        className ? className : ""
      }`}
      style={{ backgroundColor: heavyStyle ? "#42a942" : "" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      key={message}
      ref={errorRef}
    >
      <div className="flex">
        <div className="mx-1">
          <div
            className={`text-base ${heavyStyle ? "text-white" : `text-[#42a942]`}`}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Success;
